// Perkakas bersama untuk widget belajar interaktif: seret (pointer), koordinat SVG,
// animasi yang menghormati "kurangi gerakan", dan format angka/pecahan.
import { prefersReducedMotion } from '../core/dom.js';
import { F, fmt } from '../core/format.js';
import { simp } from '../core/math.js';

export { F, fmt, simp };
export const gerakHalus = () => !prefersReducedMotion();
export const jeda = ms => new Promise(r => setTimeout(r, gerakHalus() ? ms : 0));
export const batas = (v, a, b) => Math.min(b, Math.max(a, v));
export const pecahan = (n, d) => (d === 1 ? `${n}` : F(n, d));
export const angkaID = n => fmt(n);

// Animasi Web Animations API; dilewati (langsung selesai) bila pengguna memilih kurangi gerakan.
export function animasi(el, keyframes, opsi = {}) {
  if (!el?.animate || !gerakHalus()) return Promise.resolve();
  return el.animate(keyframes, { duration: 400, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'none', ...opsi }).finished.catch(() => {});
}
export const goyang = el => animasi(el, [{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(-3px)' }, { transform: 'translateX(0)' }], { duration: 350 });
export const letup = el => animasi(el, [{ transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }], { duration: 380 });

// Koordinat pointer dalam sistem koordinat viewBox sebuah <svg>.
export function titikSVG(svg, e) {
  const pt = svg.createSVGPoint();
  pt.x = e.clientX; pt.y = e.clientY;
  const m = svg.getScreenCTM();
  return m ? pt.matrixTransform(m.inverse()) : { x: 0, y: 0 };
}

/**
 * Seret dengan pointer (mouse, sentuh, pena). onGerak dipanggil dengan event pointer.
 * Mengembalikan fungsi pelepas.
 */
export function seret(el, { onMulai, onGerak, onSelesai } = {}) {
  let aktif = false;
  const turun = e => {
    if (e.button > 0) return;
    aktif = true;
    try { el.setPointerCapture(e.pointerId); } catch (x) { /* abaikan */ }
    onMulai?.(e);
    onGerak?.(e);
    e.preventDefault();
  };
  const gerak = e => { if (aktif) { onGerak?.(e); e.preventDefault(); } };
  const naik = e => { if (!aktif) return; aktif = false; onSelesai?.(e); };
  el.addEventListener('pointerdown', turun);
  el.addEventListener('pointermove', gerak);
  el.addEventListener('pointerup', naik);
  el.addEventListener('pointercancel', naik);
  el.style.touchAction = 'none';
  return () => {
    el.removeEventListener('pointerdown', turun);
    el.removeEventListener('pointermove', gerak);
    el.removeEventListener('pointerup', naik);
    el.removeEventListener('pointercancel', naik);
  };
}

// Tombol plus/minus kecil untuk mengatur bilangan bulat.
export const pengatur = (id, label, nilai, { min = 1, max = 12 } = {}) =>
  `<div class="pengatur" data-pengatur="${id}" data-min="${min}" data-max="${max}"><span>${label}</span><button type="button" class="btn btn-sm" data-ubah="-1" aria-label="Kurangi ${label}">−</button><b aria-live="polite">${nilai}</b><button type="button" class="btn btn-sm" data-ubah="1" aria-label="Tambah ${label}">+</button></div>`;

/** Pasang perilaku semua .pengatur di host. onUbah(id, nilaiBaru) */
export function pasangPengatur(host, nilai, onUbah) {
  host.querySelectorAll('[data-pengatur]').forEach(p => {
    const id = p.dataset.pengatur, min = +p.dataset.min, max = +p.dataset.max;
    p.querySelectorAll('[data-ubah]').forEach(b => b.addEventListener('click', () => {
      const v = batas(nilai[id] + Number(b.dataset.ubah), min, max);
      if (v === nilai[id]) return;
      nilai[id] = v;
      p.querySelector('b').textContent = v;
      onUbah(id, v);
    }));
  });
}
